const TableRowsPerPageService = {
  get () {
    return JSON.parse(localStorage.getItem('rowsPerPage')) || -1
  },

  set (rowsPerPage) {
    localStorage.setItem('rowsPerPage', JSON.stringify(rowsPerPage))
  },
}

export default TableRowsPerPageService
